import { useEffect, useState } from "react";
import { Accordion, Form, Modal } from "react-bootstrap";
import { useMutation } from "react-query";
import { toast } from "react-toastify";
import { DEV_SERVER } from "../../../constants/urls";
import axios from "axios";
import { userSignal } from "../../../signal/userSignal";
import Select from 'react-select';
import { allUsersSignal } from "../../../signal/allUsersSignal";
import { stateNames } from "../../../utilities/stateNames";
import { organisationSignal } from "../../../signal/organisationSignal";
import { myGrpsSignal } from "../../../signal/myGrpsSIgnals";

export default function EditEmployeeModal(props) {

    const [employee, setEmployee] = useState({
        name: "",
        phoneNumber: "",
        userType: "",
        designation: "",
        isAdmin: false,
        state: "",
        group: "",
        orderCommissionInPercentage: 0.0,
        ruleType: "default",
        tripRules: [],
        fixedExpenses: [],
        expenseTypes: [],
        modeOfTransports: [],
        dailyAllowanceRules: [],
        compensationPerKm: 0.0,
        availableLeaves: 0,
        managerId: ""
    })

    useEffect(() => {
        if (props.employee) {
            setEmployee((prev) => {

                if (!props?.employee?.tripRules) {
                    props.employee.tripRules = []
                }
                if (!props?.employee?.fixedExpenses) {
                    props.employee.fixedExpenses = []
                }
                if (!props?.employee?.expenseTypes) {
                    props.employee.expenseTypes = []
                }
                if (!props?.employee?.modeOfTransports) {
                    props.employee.modeOfTransports = []
                }
                if (!props?.employee?.dailyAllowanceRules) {
                    props.employee.dailyAllowanceRules = []
                }
                return { ...prev, ...props.employee }
            })
        }
    }, [])

    const editUser = useMutation((data) => {
        let resp = axios.put(`${DEV_SERVER}/auth/v2/employee/${data.id}`, data.body, {
            headers: {
                Authorization: `Bearer ${userSignal.value?.token}`,
            },
        });
        return resp
    }, {
        onSuccess: (data1) => {
            data1 = data1.data;
            if (data1?.status) {
                toast.success(data1?.message);
                props?.refetchEmployees();
                props?.close();
            } else {
                toast.error(data1?.message);
            }
        },

        onError: (error) => {
            if (error?.response?.data?.message) {
                toast.error(error?.response.data.message);
            } else {
                toast.error("Something went wrong");
            }
        }
    })

    const handleEditEmployee = async () => {

        if (employee?.name === "") {
            toast.error("Name is required");
            return;
        }
        if (employee?.phoneNumber === "") {
            toast.error("Phone Number is required");
            return;
        }
        if (employee?.userType === "") {
            toast.error("User Type is required");
            return;
        }

        let body = {
            id: employee?.id,
            body: {
                name: employee.name,
                phoneNumber: parseInt(employee.phoneNumber),
                isAdmin: employee.isAdmin,
                designation: employee.designation,
                userType: employee.userType,
                availableLeaves: Math.floor(employee.availableLeaves),
                state: employee?.state || "",
                group: employee?.group || "",
            }
        }

        if (organisationSignal?.value && organisationSignal?.value?.isOrderModuleActivated) {
            body.body["orderCommissionInPercentage"] = employee.orderCommissionInPercentage
        }

        if (employee.ruleType === "default" || employee.ruleType === "") {
            body.body["ruleType"] = "default"
            body.body["tripRules"] = []
            body.body["fixedExpenses"] = []
            body.body["expenseTypes"] = []
            body.body["modeOfTransports"] = []
            body.body["dailyAllowanceRules"] = []
            body.body["compensationPerKm"] = 0.0
        } else {
            let flag = true

            if (employee?.tripRules?.length || employee?.fixedExpenses?.length || employee?.modeOfTransports?.length || employee?.dailyAllowanceRules?.length) {
                if (employee?.tripRules && employee?.tripRules?.length !== 0) {
                    await new Promise((resolve, reject) => {
                        employee?.tripRules.map((rule, index) => {

                            if (rule?.name === "") {
                                toast.error(`Rule ${index + 1} name is required`);
                                reject()
                            }

                            if (rule?.conditions && rule?.conditions?.length === 0) {
                                toast.error(`Rule ${index + 1} must have at least one condition`);
                                reject()
                            }

                            if (rule?.conditions && rule?.conditions?.length) {
                                rule?.conditions?.map((condition, index2) => {
                                    if (condition.field === "") {
                                        toast.error(`Rule ${index + 1} condition ${index2 + 1} field is required`);
                                        reject()
                                    }

                                    if (condition.operator === "") {
                                        toast.error(`Rule ${index + 1} condition ${index2 + 1} operator is required`);
                                        reject()
                                    }

                                    if (condition.value === "") {
                                        toast.error(`Rule ${index + 1} condition ${index2 + 1} value is required`);
                                        reject()
                                    }
                                })
                            }
                        })
                        resolve()
                    }).catch(err => {
                        console.log(err)
                        flag = false;
                    })
                }

                if (employee?.fixedExpenses && employee?.fixedExpenses?.length) {
                    await new Promise((resolve, reject) => {
                        employee?.fixedExpenses?.map(async (expense, index) => {
                            if (expense?.name === "") {
                                toast.error(`Expense ${index + 1} name is required`);
                                reject();
                            }

                            if (expense?.amount === "") {
                                toast.error(`Expense ${index + 1} amount is required`);
                                reject();
                            }
                        })
                        resolve()
                    }).catch(err => {
                        console.log(err)
                        flag = false
                    })
                }

                if (employee?.expenseTypes && employee?.expenseTypes?.length) {
                    await new Promise((resolve, reject) => {
                        employee?.expenseTypes?.map(async (expense, index) => {
                            if (expense?.name === "") {
                                toast.error(`Expense Type ${index + 1} name is required`);
                                reject();
                            }
                        })
                        resolve()
                    }).catch(err => {
                        console.log(err)
                        flag = false
                    })
                }

                if (employee?.modeOfTransports && employee?.modeOfTransports?.length) {
                    await new Promise((resolve, reject) => {
                        employee?.modeOfTransports?.map(async (mode, index) => {
                            if (mode?.name === "") {
                                toast.error(`Mode of Transport ${index + 1} name is required`);
                                reject();
                            }

                            if (mode?.amount === "") {
                                toast.error(`Mode of Transport ${index + 1} amount is required`);
                                reject();
                            }
                        })
                        resolve()
                    }).catch(err => {
                        console.log(err)
                        flag = false
                    })
                }

                if (employee?.dailyAllowanceRules && employee?.dailyAllowanceRules?.length) {
                    await new Promise((resolve, reject) => {
                        employee?.dailyAllowanceRules?.map(async (rule, index) => {
                            if (rule?.name === "") {
                                toast.error(`Daily Allowance Rule ${index + 1} name is required`);
                                reject();
                            }

                            if (rule?.amount === "") {
                                toast.error(`Daily Allowance Rule ${index + 1} amount is required`);
                                reject();
                            }
                        })
                        resolve()
                    }).catch(err => {
                        console.log(err)
                        flag = false
                    })
                }
            }

            if (!flag) {
                return
            }

            body.body["ruleType"] = "custom"
            body.body["tripRules"] = employee?.tripRules
            body.body["fixedExpenses"] = employee?.fixedExpenses
            body.body["expenseTypes"] = employee?.expenseTypes
            body.body["modeOfTransports"] = employee?.modeOfTransports
            body.body["dailyAllowanceRules"] = employee?.dailyAllowanceRules
            body.body["compensationPerKm"] = employee?.compensationPerKm
        }

        editUser.mutate(body);
    }

    return (
        <Modal show={props.show} fullscreen onHide={() => props.close()}>
            <Modal.Header closeButton>
                <Modal.Title>Edit Employee</Modal.Title>
            </Modal.Header>
            <Modal.Body className="d-flex align-items-center flex-column" style={{ rowGap: "1rem" }}>
                <div className="d-flex align-items-center flex-column w-50 mx-auto" style={{ rowGap: "1rem" }}>
                    <Form.Group className="mb-3 w-100" controlId="formBasicName">
                        <Form.Label>Name</Form.Label>
                        <Form.Control value={employee?.name} onChange={(e) => setEmployee({ ...employee, name: e.target.value })} type="text" placeholder="Enter name" />
                    </Form.Group>
                    <Form.Group className="mb-3 w-100" controlId="formBasicPhoneNumber">
                        <Form.Label>Phone Number</Form.Label>
                        <Form.Control value={employee?.phoneNumber} onChange={(e) => {
                            if (e.target.value.length > 10) {
                                return;
                            }
                            setEmployee({ ...employee, phoneNumber: e.target.value })
                        }} type="number" placeholder="Enter phone number" />
                    </Form.Group>

                    <Form.Group className="mb-3 w-100" controlId="formBasicState">
                        <Form.Label>State</Form.Label>
                        <Select
                            options={stateNames.map((state) => ({ value: state, label: state }))}
                            onChange={(e) => {
                                setEmployee({ ...employee, state: e.value })
                            }}
                            value={{ value: employee?.state, label: employee?.state }}
                        />
                    </Form.Group>

                    <Form.Group className="mb-3 w-100" controlId="formBasicDesignation">
                        <Form.Label>Designation</Form.Label>
                        <Form.Control value={employee?.designation} onChange={(e) => setEmployee({ ...employee, designation: e.target.value })} type="text" placeholder="Enter designation" />
                    </Form.Group>

                    <Form.Group className="mb-3 w-100" controlId="formBasicAvailableLeaves">
                        <Form.Label>Available Leaves</Form.Label>
                        <Form.Control value={employee?.availableLeaves} onChange={(e) => setEmployee({ ...employee, availableLeaves: e.target.value })} type="number" placeholder="Enter available leaves" />
                    </Form.Group>

                    {organisationSignal?.value && organisationSignal?.value?.isOrderModuleActivated && <Form.Group className="mb-3 w-100" controlId="formBasicOrderCommissionInPercentage">
                        <Form.Label>Order Commission In Percentage</Form.Label>
                        <Form.Control value={employee?.orderCommissionInPercentage} onChange={(e) => setEmployee({ ...employee, orderCommissionInPercentage: parseFloat(e.target.value) })} type="number" placeholder="Enter order commission in percentage" />
                    </Form.Group>}

                    <Form.Group className="mb-3 w-100" controlId="formBasicState">
                        <Form.Label>State</Form.Label>
                        <Select as="select"
                            options={myGrpsSignal.value?.map((grp) => ({ value: grp, label: grp }))}
                            value={{ value: employee?.group, label: employee?.group }}
                            onChange={(e) => setEmployee({ ...employee, group: e?.value })}
                            isSearchable
                        />
                    </Form.Group>

                    <Form.Group className="mb-3 w-100" controlId="formBasicUserType">
                        <Form.Label>User Type</Form.Label>
                        <div className="d-flex" style={{ columnGap: "1rem" }}>
                            <Form.Check
                                type="radio"
                                label="Employee"
                                name="formHorizontalRadios"
                                id="formHorizontalRadios1"
                                checked={employee?.userType === "employee"}
                                onClick={() => setEmployee({ ...employee, userType: "employee", isAdmin: false })}
                            />
                            <Form.Check
                                type="radio"
                                label="Manager"
                                name="formHorizontalRadios" 
                                id="formHorizontalRadios2"
                                checked={employee?.userType === "manager" && !employee?.isAdmin}
                                onClick={() => setEmployee({ ...employee, userType: "manager", isAdmin: false })}
                            />
                            <Form.Check
                                type="radio"
                                label="Office Staff"
                                name="formHorizontalRadios"
                                id="formHorizontalRadios4"
                                checked={employee?.userType === "officestaff"} // Add this line
                                onClick={() => setEmployee({ ...employee, userType: "officestaff", isAdmin: false })}
                            />
                            <Form.Check
                                type="radio"
                                label="Super Admin"
                                name="formHorizontalRadios"
                                id="formHorizontalRadios3"
                                checked={employee?.userType === "manager" && employee?.isAdmin}
                                onClick={() => setEmployee({ ...employee, userType: "manager", isAdmin: true })}
                            />
                        </div>
                    </Form.Group>

                    <Form.Group className="w-100" controlId="formBasicRuleType">
                        <Form.Check
                            type="checkbox"
                            label="Trip Rules as default rules set by organisation"
                            name="formHorizontalRadios"
                            id="formHorizontalRadios4"
                            checked={employee?.ruleType === "default" || employee?.ruleType === ""}
                            onChange={(e) => setEmployee({ ...employee, ruleType: e.target.checked ? "default" : "custom" })}
                        />
                    </Form.Group>

                    {
                        employee?.ruleType === "custom" &&
                        <>
                            <div style={{ display: "flex", columnGap: "1rem" }}>
                                <Form.Group className="form-group d-flex align-items-center" style={{ columnGap: "1rem", textWrap: "nowrap" }}>
                                    <Form.Label htmlFor="compensationPerKm" className="">Compensation Per Km:</Form.Label>
                                    <Form.Control type="number" className="" id="compensationPerKm" aria-describedby="compensationPerKm" placeholder="Compensation Per Km" value={employee?.compensationPerKm} onChange={(e) => {
                                        setEmployee({ ...employee, compensationPerKm: parseFloat(e.target.value) })
                                    }} />
                                </Form.Group >
                            </div>

                            <div style={{ display: "flex", flexDirection: "column", width: "100%" }} className="mb-3">
                                <Accordion>
                                    <Accordion.Item eventKey="0">
                                        <Accordion.Header>Mode Of Transports</Accordion.Header>
                                        <Accordion.Body>
                                            <div>
                                                {employee?.modeOfTransports?.length > 0 && employee?.modeOfTransports.map((mode, index) => {
                                                    return (
                                                        <div key={index} className='d-flex flex-column mb-2'>
                                                            <div style={{ display: "flex", columnGap: "1rem", alignItems: "center" }}>
                                                                <Form.Group className="form-group">
                                                                    <i>{(index + 1) + "."}</i>
                                                                </Form.Group>
                                                                <Form.Group className="form-group">
                                                                    <Form.Control type="text" className="" id="name" aria-describedby="name" placeholder="Mode Name" value={mode.name} onChange={(e) => {
                                                                        let temp = [...employee?.modeOfTransports]
                                                                        temp[index].name = e.target.value
                                                                        setEmployee({ ...employee, modeOfTransports: temp })
                                                                    }} />
                                                                </Form.Group >
                                                                <Form.Group className="form-group">
                                                                    <Form.Control type="number" className="" id="amount" aria-describedby="amount" placeholder="Amount" value={parseFloat(mode.amount || 0)} onChange={(e) => {
                                                                        let temp = [...employee?.modeOfTransports]
                                                                        temp[index].amount = parseFloat(e.target.value)
                                                                        setEmployee({ ...employee, modeOfTransports: temp })
                                                                    }} />
                                                                </Form.Group >
                                                                <Form.Group className="form-group">
                                                                    <i className='fa fa-trash' style={{ cursor: "pointer" }} onClick={() => {
                                                                        let temp = [...employee?.modeOfTransports]
                                                                        temp.splice(index, 1)
                                                                        setEmployee({ ...employee, modeOfTransports: temp })
                                                                    }}></i>
                                                                </Form.Group >
                                                            </div>
                                                        </div>
                                                    )
                                                })}
                                                <button className='btn btn-light mt-2' onClick={() => {
                                                    let temp = [...employee?.modeOfTransports]
                                                    temp.push({ name: "", amount: parseFloat(0) })
                                                    setEmployee({ ...employee, modeOfTransports: temp })
                                                }}>Add Transport</button>
                                            </div>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                </Accordion>
                            </div>

                            <div style={{ display: "flex", flexDirection: "column", width: "100%" }} className="mb-3">
                                <Accordion>
                                    <Accordion.Item eventKey="0">
                                        <Accordion.Header>Daily Allowance Rules</Accordion.Header>
                                        <Accordion.Body>
                                            <div>
                                                {employee?.dailyAllowanceRules?.length > 0 && employee?.dailyAllowanceRules.map((rule, index) => {
                                                    return (
                                                        <div key={index} className='d-flex flex-column mb-2'>
                                                            <div style={{ display: "flex", columnGap: "1rem", alignItems: "center" }}>
                                                                <Form.Group className="form-group">
                                                                    <i>{(index + 1) + "."}</i>
                                                                </Form.Group>
                                                                <Form.Group className="form-group">
                                                                    <Form.Control type="text" className="" id="name" aria-describedby="name" placeholder="Rule Name" value={rule.name} onChange={(e) => {
                                                                        let temp = [...employee?.dailyAllowanceRules]
                                                                        temp[index].name = e.target.value
                                                                        setEmployee({ ...employee, dailyAllowanceRules: temp })
                                                                    }} />
                                                                </Form.Group >
                                                                <Form.Group className="form-group">
                                                                    <Form.Control type="number" className="" id="amount" aria-describedby="amount" placeholder="Amount" value={rule.amount || 0} onChange={(e) => {
                                                                        let temp = [...employee?.dailyAllowanceRules]
                                                                        temp[index].amount = parseFloat(e.target.value)
                                                                        setEmployee({ ...employee, dailyAllowanceRules: temp })
                                                                    }} />
                                                                </Form.Group >
                                                                <Form.Group className="form-group">
                                                                    <i className='fa fa-trash' style={{ cursor: "pointer" }} onClick={() => {
                                                                        let temp = [...employee?.dailyAllowanceRules]
                                                                        temp.splice(index, 1)
                                                                        setEmployee({ ...employee, dailyAllowanceRules: temp })
                                                                    }}></i>
                                                                </Form.Group >
                                                            </div>
                                                        </div>
                                                    )
                                                })}
                                                <button className='btn btn-light mt-2' onClick={() => {
                                                    let temp = [...employee?.dailyAllowanceRules]
                                                    temp.push({ name: "", amount: parseFloat(0) })
                                                    setEmployee({ ...employee, dailyAllowanceRules: temp })
                                                }}>Add Rule</button>
                                            </div>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                </Accordion>
                            </div>

                            <div style={{ display: "flex", flexDirection: "column", width: "100%" }} className="mb-3">
                                <Accordion>
                                    <Accordion.Item eventKey="0">
                                        <Accordion.Header>Trip Rules</Accordion.Header>
                                        <Accordion.Body>
                                            <div>
                                                {employee?.tripRules?.length > 0 && employee?.tripRules.map((rule, index) => {
                                                    return (
                                                        <div key={index} className='d-flex flex-column mb-2'>
                                                            <div style={{ display: "flex", columnGap: "1rem", alignItems: "center" }}>
                                                                <Form.Group className="form-group">
                                                                    <i>{(index + 1) + "."}</i>
                                                                </Form.Group>
                                                                <Form.Group className="form-group">
                                                                    <Form.Control type="text" className="" id="name" aria-describedby="name" placeholder="Rule Name" value={rule.name} onChange={(e) => {
                                                                        let temp = [...employee?.tripRules]
                                                                        temp[index].name = e.target.value
                                                                        setEmployee({ ...employee, tripRules: temp })
                                                                    }} />
                                                                </Form.Group >
                                                                <Form.Group className="form-group">
                                                                    <Form.Control as="select" className="" id="type" aria-describedby="type" placeholder="Rule Type" value={rule.conditionType} onChange={(e) => {
                                                                        let temp = [...employee?.tripRules]
                                                                        temp[index].conditionType = e.target.value
                                                                        setEmployee({ ...employee, tripRules: temp })
                                                                    }
                                                                    }>
                                                                        <option value="any">Any</option>
                                                                        <option value="all">All</option>
                                                                    </Form.Control>
                                                                </Form.Group >
                                                                <Form.Group className="form-group">
                                                                    <Form.Control type="number" className="" id="amount" aria-describedby="amount" placeholder="Amount" value={rule.amount || 0} onChange={(e) => {
                                                                        let temp = [...employee?.tripRules]
                                                                        temp[index].amount = parseFloat(e.target.value)
                                                                        setEmployee({ ...employee, tripRules: temp })
                                                                    }} />
                                                                </Form.Group >
                                                                <Form.Group className="form-group">
                                                                    <i className='fa fa-trash' style={{ cursor: "pointer" }} onClick={() => {
                                                                        let temp = [...employee?.tripRules]
                                                                        temp.splice(index, 1)
                                                                        setEmployee({ ...employee, tripRules: temp })
                                                                    }}></i>
                                                                </Form.Group >
                                                            </div>
                                                            <div className='ms-5'>

                                                                {rule?.conditions?.length > 0 && rule.conditions.map((condition, index2) => {
                                                                    return (
                                                                        <div key={`condition-${index2}`} style={{ display: "flex", columnGap: "1rem", alignItems: "center" }}>
                                                                            <Form.Group className="form-group">
                                                                                <Form.Control as="select" className="" id="field" aria-describedby="field" placeholder="Field" value={condition.field} onChange={(e) => {
                                                                                    let temp = [...employee?.tripRules]
                                                                                    temp[index].conditions[index2].field = e.target.value
                                                                                    setEmployee({ ...employee, tripRules: temp })
                                                                                }}>
                                                                                    <option value="totalDistance">Total Distance</option>
                                                                                    <option value="totalNewCustomers">Total Customers</option>
                                                                                    <option value="totalExpense">Total Expense</option>
                                                                                    <option value="totalTime">Total Time</option>
                                                                                </Form.Control>
                                                                            </Form.Group >
                                                                            <Form.Group className="form-group">
                                                                                <Form.Control as="select" className="" id="operator" aria-describedby="operator" placeholder="Operator" value={condition.operator} onChange={(e) => {
                                                                                    let temp = [...employee?.tripRules]
                                                                                    temp[index].conditions[index2].operator = e.target.value
                                                                                    setEmployee({ ...employee, tripRules: temp })
                                                                                }}>
                                                                                    <option value=">">Greater than</option>
                                                                                    <option value={">="}>Greater than or equal to</option>
                                                                                    <option value="<">Less than</option>
                                                                                    <option value="<=">Less than or equal to</option>
                                                                                    <option value="=">Equal to</option>
                                                                                </Form.Control>
                                                                            </Form.Group >
                                                                            <Form.Group className="form-group">
                                                                                <Form.Control type="number" className="" id="value" aria-describedby="value" placeholder="Value" value={condition.value || 0} onChange={(e) => {
                                                                                    let temp = [...employee?.tripRules]
                                                                                    temp[index].conditions[index2].value = parseFloat(e.target.value)
                                                                                    setEmployee({ ...employee, tripRules: temp })
                                                                                }} />
                                                                            </Form.Group >
                                                                            <Form.Group className="form-group">
                                                                                <i className='fa fa-trash' style={{ cursor: "pointer" }} onClick={() => {
                                                                                    let temp = [...employee?.tripRules]
                                                                                    temp[index].conditions.splice(index2, 1)
                                                                                    setEmployee({ ...employee, tripRules: temp })
                                                                                }}></i>
                                                                            </Form.Group >
                                                                        </div>
                                                                    )
                                                                })}


                                                                <button className='btn btn-light' onClick={() => {
                                                                    let temp = [...employee?.tripRules]
                                                                    temp[index]?.conditions?.push({ field: "totalDistance", operator: ">", value: parseFloat(0) })
                                                                    setEmployee({ ...employee, tripRules: temp })
                                                                }}>Add Condiiton</button>
                                                            </div>
                                                        </div>
                                                    )
                                                })}
                                                <button className='btn btn-light mt-2' onClick={() => {
                                                    let temp = [...employee?.tripRules]
                                                    temp.push({ name: "", conditionType: "any", conditions: [], amount: parseFloat(0) })
                                                    setEmployee({ ...employee, tripRules: temp })
                                                }}>Add Rule</button>
                                            </div>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                </Accordion>
                            </div>
                            <div style={{ display: "flex", flexDirection: "column", width: "100%" }} className="mb-3">
                                <Accordion>
                                    <Accordion.Item eventKey="0">
                                        <Accordion.Header>Fixed Expenses</Accordion.Header>
                                        <Accordion.Body>
                                            <div>
                                                {employee?.fixedExpenses?.length > 0 && employee?.fixedExpenses.map((expense, index) => {
                                                    return (
                                                        <div key={index} className='d-flex flex-column mb-2'>
                                                            <div style={{ display: "flex", columnGap: "1rem", alignItems: "center" }}>
                                                                <Form.Group className="form-group">
                                                                    <i>{(index + 1) + "."}</i>
                                                                </Form.Group>
                                                                <Form.Group className="form-group">
                                                                    <Form.Control type="text" className="" id="name" aria-describedby="name" placeholder="Rule Name" value={expense.name} onChange={(e) => {
                                                                        let temp = [...employee?.fixedExpenses]
                                                                        temp[index].name = e.target.value
                                                                        setEmployee({ ...employee, fixedExpenses: temp })
                                                                    }} />
                                                                </Form.Group >
                                                                <Form.Group className="form-group">
                                                                    <Form.Control type="number" className="" id="amount" aria-describedby="amount" placeholder="Amount" value={expense.amount || 0} onChange={(e) => {
                                                                        let temp = [...employee?.fixedExpenses]
                                                                        temp[index].amount = parseFloat(e.target.value)
                                                                        setEmployee({ ...employee, fixedExpenses: temp })
                                                                    }} />
                                                                </Form.Group >
                                                                <Form.Group className="form-group">
                                                                    <i className='fa fa-trash' style={{ cursor: "pointer" }} onClick={() => {
                                                                        let temp = [...employee?.fixedExpenses]
                                                                        temp.splice(index, 1)
                                                                        setEmployee({ ...employee, fixedExpenses: temp })
                                                                    }}></i>
                                                                </Form.Group >
                                                            </div>
                                                        </div>
                                                    )
                                                })}
                                                <button className='btn btn-light mt-2' onClick={() => {
                                                    let temp = [...employee?.fixedExpenses]
                                                    temp.push({ name: "", amount: parseFloat(0), timeDuration: "monthly" })
                                                    setEmployee({ ...employee, fixedExpenses: temp })
                                                }}>Add Rule</button>
                                            </div>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                </Accordion>
                            </div>
                            <div style={{ display: "flex", flexDirection: "column", width: "100%" }} className="mb-3">
                                <Accordion>
                                    <Accordion.Item eventKey="0">
                                        <Accordion.Header>Expenses Types</Accordion.Header>
                                        <Accordion.Body>
                                            <div>
                                                {employee?.expenseTypes?.length > 0 && employee?.expenseTypes.map((expense, index) => {
                                                    return (
                                                        <div key={index} className='d-flex flex-column mb-2'>
                                                            <div style={{ display: "flex", columnGap: "1rem", alignItems: "center" }}>
                                                                <Form.Group className="form-group">
                                                                    <i>{(index + 1) + "."}</i>
                                                                </Form.Group>
                                                                <Form.Group className="form-group">
                                                                    <Form.Control type="text" className="" id="name" aria-describedby="name" placeholder="Rule Name" value={expense.name} onChange={(e) => {
                                                                        let temp = [...employee?.expenseTypes]
                                                                        temp[index].name = e.target.value
                                                                        setEmployee({ ...employee, expenseTypes: temp })
                                                                    }}
                                                                    />
                                                                </Form.Group >
                                                            </div>
                                                        </div>
                                                    )
                                                })}
                                                <button className='btn btn-light mt-2' onClick={() => {
                                                    let temp = [...employee?.expenseTypes]
                                                    temp.push({ name: "" })
                                                    setEmployee({ ...employee, expenseTypes: temp })
                                                }}>Add Expense Type</button>
                                            </div>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                </Accordion>
                            </div>
                        </>
                    }
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-primary" onClick={handleEditEmployee}>Edit Employee</button>
            </Modal.Footer>
        </Modal>
    )
}